import React from 'react';
import './Pages.css';

function Privacy() {
  return (
    <div className="page-container">
      <h1 className="page-title">隐私政策</h1>
      <p className="subtitle">Privacy Policy</p>
      <p className="last-updated">最后更新日期：2026年1月16日</p>

      <div className="content-card">
        <h2>概述</h2>
        <p>
          欢迎使用六边形贪吃蛇（HexaSnake Hive）。我们非常重视您的隐私保护。
          本隐私政策旨在帮助您了解我们如何收集、使用、存储和保护您的信息。
        </p>
        <p>
          <strong>简而言之：我们不收集、不存储、不共享您的任何个人信息。</strong>
        </p>
      </div>

      <div className="content-card">
        <h2>1. 信息收集</h2>
        <h3>1.1 我们不收集的信息</h3>
        <p>六边形贪吃蛇是一款完全离线的单机游戏，我们不会收集以下任何信息：</p>
        <ul>
          <li>个人身份信息（姓名、邮箱、电话号码等）</li>
          <li>设备标识符（IDFA、设备ID等）</li>
          <li>位置信息</li>
          <li>游戏数据或统计信息</li>
          <li>使用习惯或行为数据</li>
          <li>任何其他个人或非个人信息</li>
        </ul>

        <h3>1.2 本地数据存储</h3>
        <p>游戏会在您的设备本地存储以下信息：</p>
        <ul>
          <li><strong>最高分记录</strong>：存储在设备本地，用于显示您的历史最佳成绩</li>
        </ul>
        <p>这些数据仅存储在您的设备上，不会上传到任何服务器，也不会与任何第三方共享。</p>
      </div>

      <div className="content-card">
        <h2>2. 信息使用</h2>
        <p>由于我们不收集任何信息，因此不存在信息使用的情况。</p>
        <p>您设备上本地存储的游戏数据（如最高分）仅用于提升您的游戏体验，不会被访问、分析或用于其他任何目的。</p>
      </div>

      <div className="content-card">
        <h2>3. 信息共享</h2>
        <p>我们不会与任何第三方共享您的任何信息，因为：</p>
        <ul>
          <li>我们不收集任何信息</li>
          <li>游戏完全离线运行，无网络连接</li>
          <li>没有集成任何第三方SDK或分析工具</li>
          <li>没有广告服务</li>
        </ul>
      </div>

      <div className="content-card">
        <h2>4. 数据安全</h2>
        <p>您设备上存储的游戏数据受iOS系统保护，只有游戏本身可以访问。我们采取以下措施保护您的数据安全：</p>
        <ul>
          <li>使用iOS系统提供的安全存储机制（UserDefaults）</li>
          <li>数据仅存储在应用沙盒内，其他应用无法访问</li>
          <li>不涉及任何网络传输</li>
        </ul>
      </div>

      <div className="content-card">
        <h2>5. 儿童隐私</h2>
        <p>
          六边形贪吃蛇适合所有年龄段的用户使用（分级4+）。由于我们不收集任何信息，
          因此不存在儿童隐私保护的特殊考虑。家长可以放心让孩子使用本游戏。
        </p>
      </div>

      <div className="content-card">
        <h2>6. 第三方服务</h2>
        <p>本游戏不使用任何第三方服务，包括但不限于：</p>
        <ul>
          <li>分析服务（如Google Analytics）</li>
          <li>广告服务</li>
          <li>社交媒体集成</li>
          <li>云存储服务</li>
          <li>支付服务</li>
        </ul>
      </div>

      <div className="content-card">
        <h2>7. 权限使用</h2>
        <p>本游戏不请求或使用任何系统权限，包括但不限于：</p>
        <ul>
          <li>网络访问权限</li>
          <li>位置权限</li>
          <li>相机或相册权限</li>
          <li>通讯录权限</li>
          <li>麦克风权限</li>
        </ul>
      </div>

      <div className="content-card">
        <h2>8. 数据删除</h2>
        <p>如果您希望删除游戏存储的本地数据（最高分记录），可以通过以下方式：</p>
        <ul>
          <li><strong>方式1</strong>：卸载游戏应用</li>
          <li><strong>方式2</strong>：在iOS设置中清除应用数据</li>
        </ul>
        <p>由于所有数据都存储在本地，删除后无法恢复。</p>
      </div>

      <div className="content-card">
        <h2>9. 隐私政策更新</h2>
        <p>
          我们可能会不定期更新本隐私政策。如有重大变更，我们会在应用中通知您。
          建议您定期查看本页面以了解最新信息。
        </p>
        <p>
          继续使用本应用即表示您接受更新后的隐私政策。
        </p>
      </div>

      <div className="content-card">
        <h2>10. 联系我们</h2>
        <p>如果您对本隐私政策有任何疑问或建议，请通过以下方式联系我们：</p>
        <div className="contact-info">
          <p><strong>邮箱</strong>: wsmslgh@gmail.com</p>
          <p><strong>应用名称</strong>: 六边形贪吃蛇 / HexaSnake Hive</p>
        </div>
        <p>我们会尽快回复您的咨询。</p>
      </div>

      <div className="content-card">
        <h2>11. 适用法律</h2>
        <p>
          本隐私政策受中华人民共和国法律管辖。如发生争议，应友好协商解决；
          协商不成的，可向有管辖权的人民法院提起诉讼。
        </p>
      </div>

      <div className="content-card privacy-summary">
        <h2>📝 隐私保护承诺</h2>
        <div className="commitment-box">
          <p>✅ 不收集任何个人信息</p>
          <p>✅ 不使用任何追踪技术</p>
          <p>✅ 不集成任何第三方SDK</p>
          <p>✅ 完全离线运行</p>
          <p>✅ 无广告、无内购</p>
          <p>✅ 数据仅存储在本地</p>
        </div>
        <p className="commitment-note">
          我们致力于为您提供一个安全、纯净、专注的游戏体验。您的隐私和信任对我们至关重要。
        </p>
      </div>

      <div className="content-card">
        <h2>English Version</h2>
        <p><strong>Last Updated: January 16, 2026</strong></p>
        
        <h3>Overview</h3>
        <p>
          Welcome to HexaSnake Hive. We take your privacy seriously. 
          <strong> In short: We do not collect, store, or share any of your personal information.</strong>
        </p>

        <h3>Information Collection</h3>
        <p>HexaSnake Hive is a completely offline single-player game. We do not collect any information including:</p>
        <ul>
          <li>Personal identity information</li>
          <li>Device identifiers</li>
          <li>Location data</li>
          <li>Game statistics</li>
          <li>Usage patterns or behavioral data</li>
        </ul>

        <h3>Local Data Storage</h3>
        <p>The game only stores your high score locally on your device. This data:</p>
        <ul>
          <li>Stays on your device only</li>
          <li>Is not uploaded to any server</li>
          <li>Is not shared with any third party</li>
        </ul>

        <h3>Third-Party Services</h3>
        <p>This game does not use any third-party services, including analytics, advertisements, or cloud storage.</p>

        <h3>Contact Us</h3>
        <p>If you have any questions about this Privacy Policy, please contact us at: <strong>wsmslgh@gmail.com</strong></p>
      </div>
    </div>
  );
}

export default Privacy;
